<template>
  <div>
      <budget-group-details></budget-group-details>
      <div v-if="budget.name && budget.name !== 'Monthly'">
          <budget-group-campaign-list></budget-group-campaign-list>
      </div>
  </div>
</template>

<script>

import { mapGetters } from 'vuex';
import BudgetGroupDetails from './BudgetGroupDetails.vue';
import BudgetGroupCampaignList from './BudgetGroupCampaignList.vue';

export default {
    components: {
        BudgetGroupDetails,
        BudgetGroupCampaignList,
    },

    computed: {
        ...mapGetters('client', {
			'budget': 'activeBudgetGroup',
        }),
    }
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/clients/BudgetGroupDetailsView.vue